import React from 'react'
import './attendance.css'

const Attendance = ({urole, page}) => {
  return (
    <div className='appr-attendnc-container'>Attendance</div>
  )
}

export default Attendance